import React, { Fragment } from 'react';
import HeaderPortal from '../../../components/layout/HeaderPortal';
import DocumentSignStateTransitionsContainer from './DocumentSignStateTransitionsContainer';
import PermissionCheck from 'components/common/PermissionCheck';
import { ADMIN_DOCUMENT_SIGN_STATE_TRANSITIONS } from 'constants/rightsCodes';

const Route = () => {
  return (
    <Fragment>
      <HeaderPortal />
      <PermissionCheck authorizationCode={ADMIN_DOCUMENT_SIGN_STATE_TRANSITIONS}>
        <DocumentSignStateTransitionsContainer />
      </PermissionCheck>
    </Fragment>
  );
};

export default Route;
